import './App.css';
import React, { useState, useEffect, Suspense } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';

import Home from './pages/Home.js';

import ContactBar from './components/ContactBar.js';
import NavBar from './components/NavBar.js';
import Footer from './components/Footer.js';
import About from './pages/About.js';
import Contact from './pages/Contact.js';
import Beliefs from './pages/Beliefs.js';
import Communion from './pages/Communion.js';
import Membership from './pages/Membership.js';
import Baptism from './pages/Baptism.js';
import Worship from './pages/Worship.js';
import Childcare from './pages/Childcare.js';
import ChristmasChild from './pages/ChristmasChild.js';
import FirstResponders from './pages/FirstResponders.js';
import MissionTrips from './pages/MissionTrips.js';
import PastSessions from './pages/PastSessions.js';
import CommonGrounds from './pages/CommonGrounds.js';
import DailyReadings from './pages/DailyReadings.js';
import Ministries from './pages/Ministries.js';
import PastService from './pages/PastService.js';

import Login from './pages/Login.js';
import ViewMissionTrip from './pages/ViewMissionTrip.js';
import Announcements from './pages/Announcements.js';
import MobileNavBar from './components/MobileNavBar.js';
import NotFoundPage from './pages/NotFoundPage.js';


import ScrollToTop from './utility/ScrollToTop.js';
import Scouts from './pages/Scouts.js';
import Holidays from './pages/Holidays.js';
import VBS from './pages/VBS.js';
import OurHistory from './pages/OurHistory.js';

import about from './assets/images/sanctuaryFromPew.webp';
import childcare from './assets/images/childcareWindow.webp';
import history from './assets/images/exteriorBW.webp';
import SeptemberClub from './pages/SeptemberClub.js';
import GriefSupport from './pages/GriefSupport.js';
import WednesdayNightKids from './pages/WednesdayNightKids.js';
import Recovery from './pages/Recovery.js';
import GBH from './pages/GBH.js';
import MarshallWesley from './pages/MarshallWesley.js';
import AdminRoutes from './components/admin/AdminRoutes.js';
import hero from './assets/images/sanctuaryFull.webp';
import logo from './assets/images/umcLogo.webp';
import ForgotPassword from './pages/ForgotPassword.js';
import ResetPassword from './pages/ResetPassword.js';
import RegisterInvite from './pages/RegisterInvite.js';
import ManualPasswordReset from './pages/ManualPasswordReset.js';


function App() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isHeaderCompact, setIsHeaderCompact] = useState(window.scrollY > 24);

    useEffect(() => {
      const imagesToPreload = [logo, hero, history];

      imagesToPreload.forEach((src) => {
        const img = new Image();
        img.src = src;
      });
    }, []);

    // Update window width on resize
    useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
      window.addEventListener('resize', handleResize);
  
      return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
      const handleScroll = () => {
        const scrollPosition = window.scrollY || window.pageYOffset;
        setIsHeaderCompact((wasCompact) =>
          wasCompact ? scrollPosition > 20 : scrollPosition > 40
        );
      };

      window.addEventListener('scroll', handleScroll, { passive: true });
      handleScroll();

      return () => window.removeEventListener('scroll', handleScroll);
    }, []);

  return (
    <div className="App">
      <ScrollToTop />
      <header role="banner">
        <div className='header-wrapper'>
          {/* Conditionally render the ContactBar only for desktop screens */}
          {/*windowWidth >= 785 && <ContactBar />*/}

          {/* Conditionally render the NavBar or MobileNavBar based on screen width */}
          {/*windowWidth >= 785 ? <NavBar /> : <MobileNavBar />*/}

          {windowWidth >= 785 && <ContactBar isScrolled={isHeaderCompact} />}
          {windowWidth >= 785 ? <NavBar isScrolled={isHeaderCompact} /> : <MobileNavBar isScrolled={isHeaderCompact} />}
        </div>
        <div className='navbar-backdrop'>
            <div className='backdrop-placeholder' />
        </div>
        
      </header>
      
      <main id="main-content" className="content-wrapper">
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/beliefs" element={<Beliefs />} />
            <Route path="/communion" element={<Communion />} />
            <Route path="/membership" element={<Membership />} />
            <Route path="/baptism" element={<Baptism />} />
            <Route path="/worship" element={<Worship />} />
            <Route path="/childcare-preschool" element={<Childcare />} />
            <Route path="/operation-christmas-child" element={<ChristmasChild />} />
            <Route path="/first-responders" element={<FirstResponders />} />
            <Route path="/cub-boy-scouts" element={<Scouts />} />
            <Route path="/holidays" element={<Holidays />} />
            <Route path="/vacation-bible-school" element={<VBS />} />
            <Route path="/grief-support" element={<GriefSupport />} />
            <Route path="/wednesday-night-kids" element={<WednesdayNightKids />} />
            <Route path="/recovery-alive" element={<Recovery />} />
            <Route path="/gods-big-house" element={<GBH />} />
            <Route path="/marshall-wesley" element={<MarshallWesley />} />

            <Route path="/mission-trips" element={<MissionTrips />} />
            <Route path="/mission-trips/:id" element={<ViewMissionTrip />} />

            <Route path="/past-sessions" element={<PastSessions />} />
            <Route path="/past-session/:id" element={<PastService />} />
            <Route path="/common-grounds" element={<CommonGrounds />} />
            <Route path="/september-club" element={<SeptemberClub />} />
            <Route path="/daily-readings" element={<DailyReadings />} />
            <Route path="/ministries-outreach" element={<Ministries />} />
            <Route path="/announcements" element={<Announcements />} />
            <Route path="/our-history" element={<OurHistory />} />

            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/register" element={<RegisterInvite />} />

            <Route path="/manual-reset" element={<ManualPasswordReset />} />
            
            {AdminRoutes}





            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </main>

      {!isAdminRoute && <Footer />}
    </div>
  );
}

export default App;
